import { DeptNo, IDept } from './dept';
import { IRole, RoleNo } from './role';
import { CorpId } from './corp';

export type MemberId = string;

export enum MemberType {
    /** 内部成员 */
    internal = 0,
    /** 外部用户 */
    external = 1,
    /** 互联组织成员 */
    corp_coop = 2
}

export enum MemberStatus {
    /** 已离职 */
    dismission = -1,
    /** 邀请中 */
    unjoined = 0,
    /** 激活成员 */
    active = 1,
    /** 已彻底删除 */
    deleted = -2
}

export enum MemberFrozenStatus {
    /** 已启用 */
    default = 0,
    /** 已禁用 */
    frozen = 2
}

export interface IMember {
    _id: MemberId;
    /** 成员类型 */
    type: MemberType;
    /** 所处企业中的昵称 */
    nickname: string;
    /** 所处企业中的编号 */
    username: string;
    /** 头像地址 */
    avatar?: string;
    phone?: string;
    is_phone_verified?: boolean;
    email?: string;
    is_email_verified?: boolean;
    /** 账号状态 */
    status: MemberStatus;
    frozen?: MemberFrozenStatus; // 冻结状态
    /** 所属部门编号列表 */
    dept: DeptNo[];
    /** 所属角色编号列表 */
    role?: RoleNo[];
    is_owner?: boolean; // 是否是企业创建者
    /** 所属部门名称数组(搜索时显示) */
    label?: string[];
    /** 当前登录成员是否可管理该成员 */
    editable?: boolean;

    // 互联组织
    /** 是否是全局对接人 */
    is_global_docker?: CorpId;
    /** 对接的主体企业id */
    host_corp_id_list?: string[];
    /** 对接的客体企业id */
    guest_corp_id_list?: string[];

    // 互联组织成员属性
    /** 互联组织成员所在企业id */
    guest_corp_id?: CorpId;

    // 兼容结构（注释先保留下，兼容结构移除后删除）
    // member_id: MemberId;
    // name: string; // nickname
}

export type ExtValue =
    | IDept
    | IDept[]
    | IMember
    | IMember[]
    | string[]
    | string
    | number
    | null
    | undefined;

export interface ExtValues {
    [key: string]: ExtValue;
}

export interface MemberCardView extends Omit<IMember, 'role'> {
    roles?: IRole[];
    dept_path: { name: string }[];
    ext?: ExtValues; // 预设字段
}
